"use client"

import { useState, useEffect } from "react"
import { useNavigate } from "react-router-dom"
import "./NewManager.css"
import newsService from "../../../services/api/newsService"

export default function NewManagement() {
    const navigate = useNavigate()
    // State for news list
    const [news, setNews] = useState([])
    const [loading, setLoading] = useState(false)
    const [error, setError] = useState("")

    // State for form inputs
    const [formData, setFormData] = useState({
        title: "",
        description: "",
        content: "",
        photo: ["/placeholder.svg?height=100&width=300"],
        new_category: "",
    })

    // State for views
    const [showAddForm, setShowAddForm] = useState(false)

    // Fetch news on component mount
    useEffect(() => {
        fetchNews()
    }, [])

    // Fetch all news
    const fetchNews = async () => {
        try {
            setLoading(true)
            const response = await newsService.getAllNews()
            console.log('Fetched news:', response)
            // API returns an array directly, not wrapped in an object
            setNews(Array.isArray(response) ? response : [])
        } catch (error) {
            console.error("Error fetching news:", error)
            setError("Không thể tải danh sách tin tức")
        } finally {
            setLoading(false)
        }
    }

    // Handle form input changes
    const handleInputChange = (e) => {
        const { name, value } = e.target
        setFormData({
            ...formData,
            [name]: value,
        })
    }

    // Handle image upload
    const handleImageChange = (e) => {
        if (e.target.files && e.target.files[0]) {
            const reader = new FileReader()
            reader.onload = (event) => {
                if (event.target && event.target.result) {
                    setFormData({
                        ...formData,
                        photo: [event.target.result.toString()],
                    })
                }
            }
            reader.readAsDataURL(e.target.files[0])
        }
    }

    // Handle form submission
    const handleSubmit = async (e) => {
        e.preventDefault()
        try {
            setLoading(true)
            await newsService.createNews(formData)
            await fetchNews()
            // Reset form
            setFormData({
                title: "",
                description: "",
                content: "",
                photo: ["/placeholder.svg?height=100&width=300"],
                new_category: "",
            })
            // Hide the form after submission
            setShowAddForm(false)
        } catch (error) {
            console.error("Error creating news:", error)
            setError("Không thể tạo tin tức mới")
        } finally {
            setLoading(false)
        }
    }

    // Handle news deletion
    const handleDelete = async (id) => {
        if (window.confirm("Bạn có chắc chắn muốn xóa tin tức này không?")) {
            try {
                setLoading(true)
                await newsService.deleteNews(id)
                await fetchNews()
            } catch (error) {
                console.error("Error deleting news:", error)
                setError("Không thể xóa tin tức")
            } finally {
                setLoading(false)
            }
        }
    }

    // Toggle add form
    const toggleAddForm = () => {
        setShowAddForm(!showAddForm)
    }

    return (
        <div className="nm-container">
            <h1 className="nm-heading">Quản Lý Tin Tức</h1>
            {error && <div className="error-message">{error}</div>}
            {loading && <div className="loading-spinner">Đang tải...</div>}
            <div className="nm-layout">
                <div className="nm-list-container">
                    <div className="nm-list-header">
                        <h2 className="nm-subheading">Danh Sách Tin Tức</h2>
                        <button className="nm-add-button" onClick={toggleAddForm} disabled={loading}>
                            {showAddForm ? "Ẩn Form" : "Thêm Bài Viết Mới"}
                        </button>
                    </div>
                    <div className="nm-list">
                        {Array.isArray(news) && news.length > 0 ? (
                            news.map((item) => (
                                <div key={item._id} className="nm-card">
                                    <div className="nm-title-image">
                                        <img src={item.photo?.[0] || "/placeholder.svg"} alt={`Ảnh ${item.title}`} />
                                    </div>
                                    <div className="nm-details">
                                        <h3>{item.title}</h3>
                                        <p><strong>Mô tả:</strong> {item.description}</p>
                                        <p><strong>Danh mục:</strong> {item.new_category?.name || 'Chưa phân loại'}</p>
                                        <div className="nm-actions">
                                            <button className="nm-view-button" onClick={() => navigate(`/manager/newdetailmanager/${item._id}`)}>
                                                Xem Chi Tiết
                                            </button>
                                            <button className="nm-delete-button" onClick={() => handleDelete(item._id)}>
                                                Xóa
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            ))
                        ) : (
                            <div className="no-news">Không tìm thấy tin tức nào</div>
                        )}
                    </div>
                </div>

                {showAddForm && (
                    <div className="nm-add-section">
                        <div className="nm-add-card">
                            <h2 className="nm-subheading">Thêm Bài Viết Mới</h2>
                            <form onSubmit={handleSubmit} className="nm-form">
                                <div className="nm-form-group">
                                    <label htmlFor="title">Tiêu đề bài viết</label>
                                    <input
                                        type="text"
                                        id="title"
                                        name="title"
                                        value={formData.title}
                                        onChange={handleInputChange}
                                        required
                                    />
                                </div>

                                <div className="nm-form-group">
                                    <label htmlFor="description">Mô tả</label>
                                    <textarea
                                        id="description"
                                        name="description"
                                        value={formData.description}
                                        onChange={handleInputChange}
                                        rows="4"
                                        required
                                    />
                                </div>

                                <div className="nm-form-group">
                                    <label htmlFor="content">Nội dung</label>
                                    <textarea
                                        id="content"
                                        name="content"
                                        value={formData.content}
                                        onChange={handleInputChange}
                                        rows="8"
                                        required
                                    />
                                </div>

                                <div className="nm-form-group">
                                    <label htmlFor="new_category">Danh mục</label>
                                    <select
                                        id="new_category"
                                        name="new_category"
                                        value={formData.new_category}
                                        onChange={handleInputChange}
                                        required
                                    >
                                        <option value="">Chọn danh mục</option>
                                        <option value="681eda79ba44305d9e27446e">Danh mục 1</option>
                                        <option value="6825a9ff0ca6bf657d5c89fb">Danh mục 2</option>
                                        <option value="6825aa420ca6bf657d5c8a04">Danh mục 3</option>
                                    </select>
                                </div>

                                <div className="nm-form-group">
                                    <label htmlFor="photo">Ảnh Bài Viết</label>
                                    <input
                                        type="file"
                                        id="photo"
                                        name="photo"
                                        onChange={handleImageChange}
                                        accept="image/*"
                                    />
                                    <div className="nm-image-preview">
                                        <img src={formData.photo[0] || "/placeholder.svg"} alt="Xem trước ảnh bài viết" />
                                        <p>Ảnh này sẽ hiển thị trong bài viết</p>
                                    </div>
                                </div>

                                <div className="nm-form-actions">
                                    <button type="button" className="nm-cancel-button" onClick={toggleAddForm}>
                                        Hủy
                                    </button>
                                    <button type="submit" className="nm-submit-button" disabled={loading}>
                                        {loading ? "Đang thêm..." : "Thêm Bài Viết"}
                                    </button>
                                </div>
                            </form>
                        </div>
                    </div>
                )}
            </div>
        </div>
    )
} 